<template>
  <el-dialog
    :title="$t('affiliateWithdrawal.auditWithdrawal')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="form" label-width="150px">
      <el-form-item :label="$t('affiliateWithdrawal.affiliate')">
        <el-input v-model="form.userName" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.totalCommission')">
        <el-input v-model="form.totalCommission" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.availableCommission')">
        <el-input v-model="form.availableCommission" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.withdrawnCommission')">
        <el-input v-model="form.withdrawnCommission" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.withdrawalAmount')">
        <el-input v-model="form.amount" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.remark')">
        <el-input v-model="form.remark" disabled />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.accountType')">
        <el-select v-model="form.accountType" disabled style="width:100%">
          <el-option
            v-for="item in accountTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.actualAmount')" required>
        <el-input v-model="form.realAmount" />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.fee')" required>
        <el-input v-model="form.fee" />
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.status')" required>
        <el-select v-model="form.state" style="width:100%">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('affiliateWithdrawal.reason')" required>
        <el-input v-model="form.auditRemark" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { auditAffiliateWithdrawal } from '@/api/affiliate/affiliateWithdrawalApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AuditAffiliateWithdrawal',
  data() {
    return {
      dialogVisible: false,
      form: {
        awId: '',
        amount: '',
        fee: '',
        state: '',
        realAmount: '',
        auditRemark: '',
        remark: '',
        accountType: '',
        userName: '',
        totalCommission: '',
        withdrawnCommission: '',
        availableCommission: ''
      },
      accountTypes: [
        { value: '1', label: this.$t('affiliateWithdrawal.alipay') },
        { value: '2', label: this.$t('affiliateWithdrawal.wechat') },
        { value: '3', label: this.$t('affiliateWithdrawal.bankCard') }
      ],
      statusOptions: [
        { value: '0', label: this.$t('affiliateWithdrawal.applying') },
        { value: '1', label: this.$t('affiliateWithdrawal.processing') },
        { value: '2', label: this.$t('affiliateWithdrawal.completed') },
        { value: '3', label: this.$t('affiliateWithdrawal.rejected') }
      ]
    }
  },
  methods: {
    open(row) {
      this.form = { ...row }
      this.dialogVisible = true
    },
    handleClose() {
      this.form = {
        awId: '',
        amount: '',
        fee: '',
        state: '',
        realAmount: '',
        auditRemark: '',
        remark: '',
        accountType: '',
        userName: '',
        totalCommission: '',
        withdrawnCommission: '',
        availableCommission: ''
      }
    },
    async handleSubmit() {
      if (!this.validateForm()) return
      
      try {
        this.form.shopId = getShopId()
        await auditAffiliateWithdrawal(this.form)
        this.$emit('refresh')
        this.dialogVisible = false
        this.$message.success(this.$t('common.operateSuccess'))
      } catch (error) {
        console.error(error)
      }
    },
    validateForm() {
      if (!this.form.realAmount) {
        this.$message.warning(this.$t('affiliateWithdrawal.actualAmountRequired'))
        return false
      }
      if (!this.form.fee) {
        this.$message.warning(this.$t('affiliateWithdrawal.feeRequired'))
        return false
      }
      if (!this.form.state) {
        this.$message.warning(this.$t('affiliateWithdrawal.statusRequired'))
        return false
      }
      if (!this.form.auditRemark) {
        this.$message.warning(this.$t('affiliateWithdrawal.reasonRequired'))
        return false
      }
      return true
    }
  }
}
</script>